import * as React from "react";
import { Authorize } from "reauthorize";

import { Grid, Button, Table, Loader } from "semantic-ui-react";

import { useSelector } from "react-redux";

import { ADMIN_ROLES } from "../../auth";

import { pathSelector } from "../selectors";
import { useCustomMedicalTypes } from "../hooks/useCustomMedicalTypes";

import { CreateModal } from "./CreateModal";

import { Link } from "redux-little-router";

export const All: React.FunctionComponent = () => {
    const path = useSelector(pathSelector);
    const [showCreateModal, setShowCreateModal] = React.useState<boolean>(false);
    const { customMedicalTypes, isLoaded } = useCustomMedicalTypes();

    const openCreateModal = React.useCallback(() => setShowCreateModal(true), []);
    const closeCreateModal = React.useCallback(() => setShowCreateModal(false), []);

    if (isLoaded === false) {
        return <Loader active />;
    }

    return (
        <>
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column width={14}>
                        <h1>Medicals</h1>
                    </Grid.Column>
                    <Grid.Column width={2} textAlign="right">
                        <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                            <Button icon="add" content="Create" onClick={openCreateModal} />
                        </Authorize>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Medical Name</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {customMedicalTypes
                                    .map(medicalType => (
                                        <Table.Row key={medicalType.id}>
                                            <Table.Cell>
                                                <Link href={`${path}/${medicalType.id}`}>
                                                    {medicalType.name}
                                                </Link>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                            </Table.Body>
                        </Table>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <CreateModal closeModal={closeCreateModal} open={showCreateModal} />
        </>
    );
};
